<template>
  <v-container fluid>
    <v-layout>
      <v-flex xs12 sm6 offset-sm3>
        <div class="py-4">
          <div class="mb-4 display-1">Stanje računa</div>
          <div class="my-2 title">Stanje računa <strong>{{user.balance}} RSD</strong></div>
          <div class="my-2 title">Dozvoljeni minus <strong>{{user.credit}} RSD</strong></div>
        </div>
        <div class="py-4">
          <div class="mt-4 display-1">Istorija transakcija</div>
          <table>
            <template class="body-2" v-for="(transaction, i) in transactions">
              <th v-if="i === 0 || formatDate(transactions[i-1].created) !== formatDate(transaction.created)">
                <td class="pt-4" colspan="3">{{formatDate(transaction.created)}}</td>
              </th>
              <tr>
                <td class="px-2">{{formatTime(transaction.created)}}</td>
                <td class="px-2 align-right">{{transaction.value}} RSD</td>
                <td class="px-2"><router-link :to="'/delivery/' + transaction.delivery_id" v-if="transaction.delivery_id">dostava</router-link></td>
              </tr>
            </template>
          </table>
        </div>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import moment from 'moment'
import 'moment/locale/sr'
import auth from '@/services/authService.js'
import userService from '@/services/userService.js'
export default {
  data () {
    return {
      user: auth.getCurrentUser(),
      transactions: userService.getTransactions()
    }
  },
  methods: {
    formatDate (d) {
      return d ? moment(d).format('Do MMMM YYYY') : ''
    },
    formatTime (d) {
      return d ? moment(d).format('HH:mm:ss') : ''
    }
  }
}
</script>

<style scoped>
  table {
    font-size: 1.1em;
  }
  td.align-right {
    text-align: right;
  }
</style>
